export default {
  checkIsNum: function (num) {
    var reg = /^[1-9]{1}[0-9]*$/
    return reg.test(num)
  },
  checkIsPhone: function (phone) {
    var reg = /^1[0123456789]\d{9}$/
    return reg.test(phone)
  },
  checkInternationalPhone: function (phone) { // 检查国际手机号是否符合规则
    var reg = /^[0123456789]\d{3,12}$/
    return reg.test(phone)
  },
  checkCityCode: function (cityCode) { // 检查国际手机区号是否符合规则
    var reg = /^\+?[0123456789]\d{1,7}$/
    return reg.test(cityCode)
  },
  checkIsEmail: function (email) {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    return reg.test(email)
  },
  checkIsVcode: function (num) {
    var reg = /^[0-9]{6}$/
    return reg.test(num)
  },
  getUrlParam: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
  },
  setCookie: function (name, value, expires, path, domain, secure) {
    var exp = new Date()
    exp.setTime(exp.getTime() + expires * 1000) // 过期时间2分钟
    document.cookie = name + '=' + escape(value) + ((exp == null) ? '' : ('; expires=' + exp.toGMTString())) + ((path == null) ? '' : ('; path=' + path)) + ((domain == null) ? '' : ('; domain=' + domain)) + ((secure === true) ? '; secure' : '')
  },
  getCookie: function (name) {
    var arg = name + '='
    var alen = arg.length
    var clen = document.cookie.length
    var i = 0
    while (i < clen) {
      var j = i + alen
      if (document.cookie.substring(i, j) === arg) {
        return this.getCookieVal(j)
      }
      i = document.cookie.indexOf(' ', i) + 1
      if (i === 0) break
    }
    return null
  },
  getCookieVal: function (offset) {
    var endstr = document.cookie.indexOf(';', offset)
    if ((endstr === -1) || (endstr === '-1')) {
      endstr = document.cookie.length
    }
    return unescape(document.cookie.substring(offset, endstr))
  },
  formatLabelHtml: function (goods) {
    if (goods.saleQuantity - goods.total >= 0) {
      return '<span class="df_state BG_d T_12_14 T_w">缺货</span>'
    } else {
      switch (parseInt(goods.label)) {
        case 0:
          return ''
        case 1:
          return '<span class="df_state BG_r T_12_14 T_w">热卖</span>'
        case 2:
          return '<span class="df_state BG_b T_12_14 T_w">限购</span>'
        case 3:
          return '<span class="df_state BG_y T_12_14 T_w">独家</span>'
        case 4:
          return '<span class="df_state BG_g T_12_14 T_w">新品</span>'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/v2/static/js/commonUtil.js